module.exports = __webpack_public_path__ + "assets/playlist-editor.4bf8d9cc.svg";